let lastScrollTop = 0;
const navbar = document.querySelector('.section-header');

window.addEventListener('scroll', () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    // Downscroll
    navbar.style.top = '-100px';
  } else {
    // Upscroll
    navbar.style.top = '0';
  }

  lastScrollTop = scrollTop;
});

// Change language
// Switch language

var enBtn = document.getElementById('en-btn');
var frBtn = document.getElementById('fr-btn');

// Function to set the active language and class
function setActiveLanguage(language) {
    if (language === 'en') {
        document.body.classList.remove('fr-lang');
        document.body.classList.add('en-lang');
        enBtn.classList.add('active');
        frBtn.classList.remove('active');
    } else if (language === 'fr') {
        document.body.classList.remove('en-lang');
        document.body.classList.add('fr-lang');
        frBtn.classList.add('active');
        enBtn.classList.remove('active');
    }
}

// Function to handle button clicks
function handleButtonClick(event) {
    var language = event.target.id.split('-')[0]; // Extract language from button ID
    setActiveLanguage(language);
    localStorage.setItem('activeLanguage', language); // Store active language in localStorage
}

// Add event listeners to buttons
enBtn.addEventListener('click', handleButtonClick);
frBtn.addEventListener('click', handleButtonClick);

// Check if active language is stored in localStorage and set it if present
var storedLanguage = localStorage.getItem('activeLanguage');
if (storedLanguage) {
    setActiveLanguage(storedLanguage);
}

// Scroll animation

// Handle scroll-triggered animations
const scrollElements = document.querySelectorAll(".js-scroll");

const elementInView = (el, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const elementOutofView = (el) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

const displayScrollElement = (element) => {
  element.classList.add("scrolled");
};

const hideScrollElement = (element) => {
  element.classList.remove("scrolled");
};

const handleScrollAnimation = () => {
  scrollElements.forEach((el) => {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el);
    }
  });
};

window.addEventListener("scroll", () => {
  handleScrollAnimation();
});

// Handle load-triggered animations
const loadElements = document.querySelectorAll(".first-animation");

const displayLoadElement = (element) => {
  element.classList.add("loaded");
};

const handleLoadAnimation = () => {
  loadElements.forEach((el) => {
    displayLoadElement(el);
  });
};

window.addEventListener("load", () => {
  handleLoadAnimation();
});
